import {
  COMMUNITY_ENGAGEMENTS,
  START_ENCOUNTERS,
  ENCOUNTERS,
  BULK_DELETE,
  ENCOUNTERS_HISTORY,
} from "constants/endpoints";
import { result } from "lodash";
import { deleteApi, get, post, put } from "services/network";
import { toast } from "react-toastify";
import CustomToast from "components/common/custom-toast";
import { alertTypes } from "constants/common";

export const getOrganizations = async (obj) => {
  const params = {
    page: obj?.page ? obj.page : 1,
    perPage: obj?.perPage ? obj.perPage : 10,
    search: obj?.search ? obj.search : "",
    filter: obj?.status ? obj.status : "",
    key: obj?.key ? obj.key : "",
    order: obj?.order ? obj.order : "",
  };
  try {
    const result = await get(
      `${COMMUNITY_ENGAGEMENTS}?filter[status]=${params.filter}&page=${params.page}&per=${params.perPage}&query=${params.search}&sort=${params.key}&order=${params.order}`,
      true
    );
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const getOrganization = async (id) => {
  try {
    const result = await get(`${COMMUNITY_ENGAGEMENTS}/${id}`, true);
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const createOrganizations = async (data, setErrors = () => {}) => {
  try {
    const result = await post(`${COMMUNITY_ENGAGEMENTS}`, data, true);
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message="Care Manager created successfully"
      />
    );
    return result;
  } catch (error) {
    if (error?.response?.data) {
      setErrors(error?.response?.data.errors);
    }
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText}
      />
    );
    console.log(error);
  }
};
export const updateOrganizations = async (data, id, setErrors = () => {}) => {
  console.log("data", data);
  try {
    const result = await put(`${COMMUNITY_ENGAGEMENTS}/${id}`, data, true);
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message="Care Manager updated successfully"
      />
    );
    return result;
  } catch (error) {
    if (error?.response?.data) {
      setErrors(error?.response?.data.errors);
    }
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText}
      />
    );
    console.log(error);
  }
};
export const deleteOrganization = async (id) => {
  try {
    const result = await deleteApi(`${COMMUNITY_ENGAGEMENTS}/${id}`, true);
    toast(<CustomToast variant={alertTypes.INFO} message={result.message} />);
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText || "test"}
      />
    );
    console.log(result);
  }
};
export const deleteBulkOrganizations = async (data) => {
  try {
    const result = await put(
      `${COMMUNITY_ENGAGEMENTS}/${BULK_DELETE}`,
      data,
      true
    );
    console.log("result", result);
    toast(<CustomToast variant={alertTypes.INFO} message={result.message} />);
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText || "test"}
      />
    );
    console.log(result);
  }
};

export const startEncounter = async (id) => {
  try {
    const result = await put(START_ENCOUNTERS(id), {}, true);
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message="Encounter started successfully"
      />
    );
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText}
      />
    );
    console.log(error);
  }
};

export const updateEncounter = async (id, data) => {
  console.log("data", data);
  try {
    const result = await put(`${ENCOUNTERS}/${id}`, data, true);
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message="Encounter submited successfully"
      />
    );
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText}
      />
    );
    console.log(error);
  }
};

export const getEncounterHistory = async (id) => {
  console.log("id", id);
  try {
    const result = await get(ENCOUNTERS_HISTORY(id), true);
    return result;
  } catch (error) {
    console.log(error);
  }
};
